  <form class="centered-content" data-amplify-form *ngIf="profileForm && !formLoading" [formGroup]="profileForm" (ngSubmit)="onSubmit($event)" >
    <h3 *ngIf="!isMapping" class="form-group">Gebruiker toevoegen</h3>
    <div class="amplify-flex amplify-authenticator__column" data-orientation="horizontal">

      <div class="form-group">
        <label class="amplify-label" for="gebruikersnaam">Gebruikersnaam*</label>
        <input type="email" class="amplify-input" id="gebruikersnaam" formControlName="gebruikersnaam">
        <div *ngIf="profileForm.get('gebruikersnaam')?.errors && profileForm.get('gebruikersnaam')?.dirty" class="error">
          <p *ngIf="profileForm.get('gebruikersnaam')?.hasError('required')">Gebruikersnaam is verplicht en moet geldig zijn.</p>
          <p *ngIf="profileForm.get('gebruikersnaam')?.hasError('notUnique')">
            {{ profileForm.get('gebruikersnaam')?.getError('notUnique') }}
          </p>
          <p *ngIf="profileForm.get('gebruikersnaam')?.hasError('uniqueFetchError')">
            {{ profileForm.get('gebruikersnaam')?.getError('uniqueFetchError') }}
          </p>
          <p *ngIf="profileForm.get('gebruikersnaam')?.hasError('maxlength')">Gebruikersnaam mag max 128 characters lang zijn</p>

        </div>
      </div>

      <div class="form-group">
        <label class="amplify-label" for="emailadres">E-mail*</label>
        <input type="email" class="amplify-input" id="emailadres" formControlName="emailadres">
        <div *ngIf="profileForm.get('emailadres')?.errors && profileForm.get('emailadres')?.dirty" class="error">
          <p *ngIf="profileForm.get('emailadres')?.hasError('required')">E-mailadres is verplicht en moet geldig zijn.</p>
          <p *ngIf="profileForm.get('emailadres')?.hasError('notUnique')">
            {{ profileForm.get('emailadres')?.getError('notUnique') }}
          </p>
          <p *ngIf="profileForm.get('emailadres')?.hasError('uniqueFetchError')">
            {{ profileForm.get('emailadres')?.getError('uniqueFetchError') }}
          </p>
          <p *ngIf="profileForm.get('emailadres')?.hasError('maxlength')">E-mailadres mag max 255 characters lang zijn</p>

        </div>
      </div>
      <div class="form-group" *ngIf="isMapping">
        <label class="amplify-label" for="passwordNew">Wachtwoord*</label>
        <input type="password" class="amplify-input" id="passwordNew" formControlName="password">

        <div *ngIf="profileForm.get('password')?.invalid && profileForm.get('password')?.touched" class="error">
          <p *ngIf="profileForm.get('password')?.hasError('minLength')">
            {{ profileForm.get('password')?.getError('minLength') }}
          </p>
          <p *ngIf="profileForm.get('password')?.hasError('numberRequired')">
            {{ profileForm.get('password')?.getError('numberRequired') }}
          </p>
          <p *ngIf="profileForm.get('password')?.hasError('specialCharRequired')">
            {{ profileForm.get('password')?.getError('specialCharRequired') }}
          </p>
          <p *ngIf="profileForm.get('password')?.hasError('upperCaseRequired')">
            {{ profileForm.get('password')?.getError('upperCaseRequired') }}
          </p>
          <p *ngIf="profileForm.get('password')?.hasError('maxlength')">Password mag max 256 characters lang zijn</p>
        </div>
      </div>
      <div class="form-group" *ngIf="isMapping">
        <label class="amplify-label" for="pwConfirm">Bevestig wachtwoord*</label>
        <input type="password" class="amplify-input" id="pwConfirm" formControlName="pwConfirm">
        <div *ngIf="profileForm.get('pwConfirm')?.errors && profileForm.get('pwConfirm')?.dirty" class="error">
          <p *ngIf="
          (profileForm.get('pwConfirm')?.hasError('passwordMismatch') &&
          !profileForm.get('pwConfirm')?.hasError('required'))
          ">Wachtwoorden komen niet overeen.</p>
        </div>
        <div *ngIf="(profileForm.get('password')?.value && !profileForm.get('pwConfirm')?.value)" class="warning">
          <p>Vergeet wachtwoord niet te bevestigen</p>
        </div>
      </div>

      <div class="form-group">
        <label class="amplify-label" for="familienaam">Familienaam*</label>
        <input type="text" class="amplify-input" id="familienaam" formControlName="familienaam">
        <div *ngIf="profileForm.get('familienaam')?.errors && profileForm.get('familienaam')?.dirty" class="error">
          <p *ngIf="profileForm.get('familienaam')?.hasError('required')">Familienaam is verplicht.</p>
          <p *ngIf="profileForm.get('familienaam')?.hasError('maxlength')">Familienaam mag max 100 characters lang zijn</p>
        </div>
      </div>

      <div class="form-group">
        <label class="amplify-label" for="voornaam">Voornaam*</label>
        <input type="text" class="amplify-input" id="voornaam" formControlName="voornaam">
        <div *ngIf="profileForm.get('voornaam')?.errors && profileForm.get('voornaam')?.dirty" class="error">
          <p *ngIf="profileForm.get('voornaam')?.hasError('required')">Voornaam is verplicht.</p>
          <p *ngIf="profileForm.get('voornaam')?.hasError('maxlength')">Voornaam mag max 100 characters lang zijn</p>
        </div>
      </div>

      <div class="form-group">
        <label class="amplify-label" for="alias">Alias</label>
        <input type="text" class="amplify-input" id="alias" formControlName="alias">
      </div>

<!--      <div class="form-group">-->
<!--        <label class="amplify-label" for="geslacht">Geslacht</label>-->
<!--        <select class="amplify-select amplify-field-group__control" [(ngModel)]="selectedGender" id="geslacht" name="geslacht" formControlName="geslacht">-->
<!--          <option *ngFor="let gender of genders" [value]="gender">{{ gender }}</option>-->
<!--        </select>-->
<!--        <div *ngIf="profileForm.get('geslacht')?.errors && profileForm.get('geslacht')?.dirty" class="error">-->
<!--          Geslacht is verplicht.-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="form-group">-->
<!--        <label class="amplify-label" for="telefoon">Telefoon</label>-->
<!--        <input type="text" class="amplify-input" id="telefoon" name="telefoon" formControlName="telefoon">-->
<!--      </div>-->

<!--      <div class="form-group">-->
<!--        <label for="adres">Adres</label>-->
<!--        <input type="text" class="amplify-input" id="adres" name="adres" formControlName="adres">-->
<!--      </div>-->

<!--      <div class="form-group">-->
<!--        <label for="postalCode">Postcode/Gemeente</label>-->
<!--        <div class="ng-autocomplete postalCode">-->
<!--          <ng-autocomplete-->
<!--            id="postalCode"-->
<!--            class=""-->
<!--            [data]="postalData"-->
<!--            searchKeyword="combined"-->
<!--            (selected)='selectPostalcode($event)'-->
<!--            (inputChanged)="searchPostalCode($event)"-->
<!--            [itemTemplate]="itemTemplate"-->
<!--            [initialValue]="initialPostal"-->
<!--            notFoundText="Niet gevonden"-->
<!--            [selectedValueRender]="selectedPostalRender"-->
<!--            [notFoundTemplate]="notFoundTemplate">-->
<!--          </ng-autocomplete>-->

<!--          <ng-template #itemTemplate let-item>-->
<!--            <a [innerHTML]=item.combined></a>-->
<!--          </ng-template>-->

<!--          <ng-template #notFoundTemplate let-notFound>-->
<!--            <div [innerHTML]="notFound"></div>-->
<!--          </ng-template>-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="form-group">-->
<!--        <label class="amplify-label" for="land">Land</label>-->
<!--        <select class="amplify-select amplify-field-group__control" id="land" formControlName="land" [(ngModel)]="selectedCountry">-->
<!--          <option *ngFor="let country of countries" [value]="country.code">{{ country.name }}</option>-->
<!--        </select>-->
<!--        <div *ngIf="profileForm.get('land')?.errors && profileForm.get('land')?.dirty" class="error">-->
<!--          Land is verplicht.-->
<!--        </div>-->
<!--      </div>-->

<!--      <div class="form-group">-->
<!--        <label class="amplify-label" for="taal">Taal</label>-->
<!--        <select class="amplify-select amplify-field-group__control" id="taal" formControlName="taal" [(ngModel)]="selectedLocale">-->
<!--          <option *ngFor="let locale of locales" [value]="locale.value">{{ locale.name }}</option>-->
<!--        </select>-->

<!--      </div>-->

      <div class="form-group" *ngIf="isSchoolAdmin">
        <label class="amplify-label" for="school">School</label>
        <select class="amplify-select amplify-field-group__control" id="school" formControlName="school" (change)="schoolChanged($event)" [(ngModel)]="selectedSchoolId">
          <option *ngFor="let school of schoolOptions" [value]="school.id">{{ school.name }}</option>
        </select>
      </div>

      <div class="form-group" *ngIf="isAdmin || isMapping">
        <label for="schoolSearch">School</label>
        <div class="ng-autocomplete postalCode">
          <ng-autocomplete
            id="schoolSearch"
            class=""
            [data]="schoolData"
            searchKeyword="name"
            (selected)='selectSchool($event)'
            (keyup)="schoolKeyUp($event)"
            (inputChanged)="searchSchools($event)"
            (inputCleared)="clearClasses()"
            [itemTemplate]="itemSchoolTemplate"
            [initialValue]="initialPostal"
            notFoundText="Niet gevonden"
            [selectedValueRender]="selectedSchoolRender"
            [notFoundTemplate]="notFoundSchoolTemplate">
          </ng-autocomplete>

          <ng-template #itemSchoolTemplate let-item>
            <a [innerHTML]=item.name></a>
          </ng-template>

          <ng-template #notFoundSchoolTemplate let-notFound>
            <div [innerHTML]="notFound"></div>
          </ng-template>
        </div>
        <div *ngIf="noValidSchool && formIsDirty" class="error">
          <p>Er werd geen correcte school geselecteerd</p>
        </div>
      </div>
      <div class="form-group" *ngIf="selectedSchool">
        <label class="amplify-label" for="klas">klas</label>
        <select
          class="amplify-select amplify-field-group__control"
          id="klas"
          formControlName="klas"
          [(ngModel)]="selectedClassId"
        >
          <option *ngFor="let klas of classOptions" [value]="klas.id">{{ klas.name }}</option>
        </select>
        <div *ngIf="noValidClass && formIsDirty" class="error">
          <p>Er werd geen correcte klas geselecteerd</p>
        </div>
      </div>

      <div class="form-group userRoles" *ngIf="selectedSchool || !isMapping">
        <label class="amplify-label" for="school_role">Gebruikersrol</label>
        <select class="amplify-select amplify-field-group__control"
                [(ngModel)]="selectedRole"
                (change)="rolesChanged()"
                id="school_role" formControlName="school_role">
          <option *ngFor="let role of Object.keys(role_map)" [value]="role_map[role]">{{ role }}</option>
        </select>
      </div>
      <div class="form-group" [hidden]="!isMappingTeacher">
        <label class="amplify-label" for="stamboek">stamboeknummer</label>
        <input (change)="stamboekChanged($event)" type="text" class="amplify-input" id="stamboek" formControlName="stamboek">
        <div *ngIf="profileForm.get('stamboek')?.errors && profileForm.get('stamboek')?.dirty" class="error">
          <p *ngIf="profileForm.get('stamboek')?.hasError('regimentalNumber')">{{ profileForm.get('stamboek')?.getError('regimentalNumber') }}</p>
          <p *ngIf="profileForm.get('stamboek')?.hasError('maxlength') || profileForm.get('stamboek')?.hasError('minlength')">Het stamboek nummer moet 11 characters lang zijn</p>
        </div>
      </div>

      <div class="form-group buttons">
        <button class="amplify-button amplify-button--fullwidth amplify-button--medium amplify-button--primary" type="submit" [disabled]="!isValid">{{isMapping ? 'Profiel Aanmaken' : 'Gebruiker opslaan'}}</button>
        <button *ngIf="!isMapping" class="amplify-button amplify-button--fullwidth amplify-button--medium amplify-button--destructive" (click)="cancel()">Annuleer</button>
      </div>


    </div>

  </form>

